"use client";

import { Toaster as Sonner } from "sonner";
import type { ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--success-bg": "rgba(15, 255, 160, 0.1)",
          "--success-border": "rgba(15, 255, 160, 0.3)",
          "--success-text": "#0FFFA0",
          "--error-bg": "rgba(255, 71, 87, 0.1)",
          "--error-border": "rgba(255, 71, 87, 0.3)",
          "--error-text": "#ff4757",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };